import { isBrowser } from './formatPrice';

export function isModalOpened() {
  if (isBrowser()) {
    return window.document.body.classList.contains('modal-open');
  }
  return false;
}
